let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7HAUt")).then(() => parcelRequire('gWF1P'));